/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 単独補助区分
 */
export type SettlementStatisticsExpenditurePatchRequestFundingTypeValue =
  (typeof SettlementStatisticsExpenditurePatchRequestFundingTypeValue)[keyof typeof SettlementStatisticsExpenditurePatchRequestFundingTypeValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettlementStatisticsExpenditurePatchRequestFundingTypeValue = {
  単独: '単独',
  補助: '補助',
} as const;
